module.exports = __webpack_public_path__ + "static/media/accessories.9ad21eb2.jpg";